import {
  ETipoOrdenacaoQuestionario,
  IAtitudeLegenda,
  ILegenda,
  IQuestResposta,
  ITreeQuestPerGru,
  utils,
  yupQuestResposta,
} from "@deltasge/marauders-map";
import {
  AccordionDetails,
  AccordionSummary,
  Grid,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { Accordion } from "components/Accordion";
import React, { FC } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { RespostaComponent } from "./RespostaComponent";

export const PerGruComponent: FC<{
  tree: ITreeQuestPerGru[];
  tipoOrdem: ETipoOrdenacaoQuestionario | null;
  ordemPai?: number | null;
  qtdeEtapas: number;
  atitudes?: IAtitudeLegenda[];
  legendas?: ILegenda[];
  nomeGrupo: string;
  nivel: number;
  nomeEtapa: string;
  etapaAtual: number;
  idAvaliacao: number;
  idsGrupos: number[];
  setResposta: (args: {
    idsGrupos: number[];
    resposta: IQuestResposta;
    index: number;
  }) => void;
}> = ({
  tree,
  qtdeEtapas,
  atitudes,
  legendas,
  nomeGrupo,
  nivel,
  nomeEtapa,
  etapaAtual,
  tipoOrdem,
  ordemPai,
  idAvaliacao,
  setResposta,
  idsGrupos,
}) => {
  return (
    <Accordion
      variant="outlined"
      defaultExpanded
      sx={{ border: nivel > 1 ? "none" : undefined }}
    >
      {nivel > 1 && (
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            pt: 0,
            pb: 0,
            m: 0,
            pl: nivel > 1 ? 1 : undefined,
            pr: nivel > 1 ? 1 : undefined,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {nomeGrupo}
          </Typography>
        </AccordionSummary>
      )}
      <AccordionDetails sx={{ p: 0 }}>
        <List sx={{ p: 0 }}>
          {tree.map((pergru, index) => {
            const { grupo, pergunta, ordem, resposta } = pergru;
            let ordenacao = tipoOrdem == null ? "" : ordem.toString();
            if (tipoOrdem == ETipoOrdenacaoQuestionario.Alfabetico) {
              ordenacao = utils.numAbbr(ordem);
            } else if (
              tipoOrdem == ETipoOrdenacaoQuestionario["Numeração Progressiva"]
            ) {
              ordenacao = `${ordemPai}${
                ordemPai ? ".".concat(ordem.toString()) : ordem
              }`;
            } else if (tipoOrdem == ETipoOrdenacaoQuestionario.Romano) {
              ordenacao = utils.romanize(ordem) || "";
            }
            return (
              <ListItem
                key={`tree-${pergru.id}-${index}`}
                divider={index + 1 < tree.length}
                sx={{ p: grupo ? 0 : 1 }}
              >
                <Grid container>
                  {grupo && grupo.id && (
                    <Grid item xs={12}>
                      <PerGruComponent
                        qtdeEtapas={qtdeEtapas}
                        tipoOrdem={grupo.tipoOrdem}
                        tree={grupo.itens}
                        atitudes={atitudes}
                        legendas={legendas}
                        ordemPai={ordem}
                        nomeGrupo={`${ordenacao} - ${grupo.nome}`}
                        nivel={nivel + 1}
                        nomeEtapa={nomeEtapa}
                        etapaAtual={etapaAtual}
                        idAvaliacao={idAvaliacao}
                        setResposta={setResposta}
                        idsGrupos={idsGrupos.concat(grupo.id)}
                      />
                    </Grid>
                  )}
                  {pergunta && (
                    <Grid item xs={12}>
                      <Typography variant="body2" component="p">
                        {ordenacao != "" ? ordenacao.concat(" - ") : ""}
                        {pergunta.texto}
                      </Typography>
                    </Grid>
                  )}
                  {pergunta && pergru.id && (
                    <Grid item xs={12}>
                      <RespostaComponent
                        pergunta={pergunta}
                        atitudes={atitudes}
                        legendas={legendas}
                        resposta={
                          resposta ?? {
                            ...yupQuestResposta.getDefault(),
                            idAvaliacao,
                            idPerguntaGrupo: pergru.id,
                            id: null,
                          }
                        }
                        qtdeEtapas={qtdeEtapas}
                        nomeEtapa={nomeEtapa}
                        etapaAtual={etapaAtual}
                        setResposta={(resposta) =>
                          setResposta({ idsGrupos, index, resposta })
                        }
                      />
                    </Grid>
                  )}
                </Grid>
              </ListItem>
            );
          })}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};
